import { render } from "./IconHover.vue?vue&type=template&id=c1a00534&scoped=true"
import script from "./IconHover.vue?vue&type=script&lang=js"
export * from "./IconHover.vue?vue&type=script&lang=js"

import "./IconHover.vue?vue&type=style&index=0&id=c1a00534&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a00534"]])

export default __exports__